import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';
const Lanes = (props) => {
  // console.log('Lanes', props);
  return (
    <React.Fragment>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout
        auctionName={props.location.state?.auctionName}
        AuctionID={props.match.params.auctionID}
      />
    </React.Fragment>
  );
};

export default observer(Lanes);
